import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { createUserPartnerAssociation } from '@/lib/partners'
import Modal from '@/widgets/Modal'
import { useRouter } from 'next/router'
import { useState } from 'react'

interface Props {
  isOpen: boolean
}

const PartnerSwitchDialog = (props: Props): JSX.Element => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  async function handleSwitchPartner(): Promise<void> {
    const partnerSlug = router.query.slug as string | undefined
    if (!partnerSlug) return
    setLoading(true)
    await createUserPartnerAssociation(partnerSlug)
    setTimeout(() => window.location.reload(), 1000)
  }

  return (
    <Modal isOpen={props.isOpen} isClosable={false}>
      <Layout className="p-4" spacing="lg">
        <Stack y>
          <div className="flex gap-2 items-center">
            <img src="/images/alert.svg" loading="lazy" width="28px" />
            <Text size="md" weight="lg">
              You're on a Different Learning Channel
            </Text>
          </div>
          <Text size="xs">It looks like you are already part of a different GetSetUp Partner Learning Channel.</Text>
          <Text size="xs" weight="lg" className="my-2!">
            🧡 Thinking of Switching?
          </Text>
          <Text size="xs">
            Please note:
            <br />
            <ul className="list-disc">
              <li>
                Your new GetSetUp experience may be limited in this new channel as different partners offer different
                class catalogs.
              </li>
              <li>This means you may lose access to some classes, articles and Helen, your Digital Assistant</li>
            </ul>
          </Text>
          <Text size="xs">
            If you prefer not to continue, click the <span className="font-semibold">Back</span> button to return
          </Text>
          <Text size="xs">
            If you're note sure, give us a call at <a href="tel:1-888-559-1614">1-888-559-1614</a> - we're happy to
            help!
          </Text>
          <Stack x spaceBetweenX="sm" justifyContent="center">
            <Button label="Back" theme="primary" onClick={() => router.push('/')} />
            <Button
              disabled={loading}
              loading={loading}
              onClick={handleSwitchPartner}
              label="Switch Anyway"
              theme="secondary"
            />
          </Stack>
        </Stack>
      </Layout>
    </Modal>
  )
}

export default PartnerSwitchDialog
